import { date, number, object, string } from 'yup';

const newPaymentSchema = object().shape({
    uuid: string().uuid().required(),
    amount: number().min(0.01).required('Monto obligatorio'),
    gatewayId: number().min(1).required('Gateway obligatorio'),
    exchangeRate: number().strict().min(1).required('Cambio obligatorio'),
    date: date().required('Fecha obligatoria'),
});

export default newPaymentSchema;
